import Alert from '@alert';
import { Apis, PATH,Utils } from '@common';
import { React } from '@common/3rd';
import { DeskForm, DeskPageBody } from '@desk-component';
import { JLLayout,JLPanelBody } from '@jl-types';
import { Modeller } from '@model';
import { AjaxResponse, ButtonType, PageComponents } from '@my-types';
import { AccountPage, AccountPageState } from './account-form';
import { OssKit } from '@common/oss-kit'
import { Checker } from '@model';

/**
 * 创建账户页面
 */
class DeskAccountCreate<P, S extends {interval: number} & AccountPageState, C extends PageComponents> extends AccountPage<P, S, C> {
	model: any;
	form: React.RefObject<any>;
	emailRef: React.RefObject<any>;
	timer: any

	constructor(props: any, context?: any) {
		super(props, context);
		this.form = React.createRef();
		this.emailRef = React.createRef();
		this.model = Modeller.asProxied({});
	}
	
	componentDidMount() {
		super.componentDidMount();
	}
	componentWillUnmount() {
		this.timer && clearInterval(this.timer);
	}
	renderPageBody() {
		return (
			<DeskPageBody where="请填写企业注册信息">
				<DeskForm model={this.model} layout={this.getLayout()} ref={this.form} />
			</DeskPageBody>
		);
	}
	private getLayout(): JLLayout {
		return {
				c: 'panel',
				header: {
					title: '账户信息'
				},
				body: {
					gridColumns: 3,
					css: () => `grid-template-columns: 660px 190px 1fr;`,
					children: [
						{
							label: '公司名称：',
							row: 1,
							input: {
								id: 'companyName',
								readonly: false,
								c: 'text',
								maxLength:100,
								check: [
									Checker.LUXURIANT.REQUIRED,
									{
										do: Checker.PREDEFINED.REGEXP,
										with: /^[\u4E00-\u9FA5A-Za-z0-9()（）]+$/,
										msg: '仅允许填写汉字、大小写字母、数字和中英文括号'
									}
								]
							}
						},
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{
							label: '公司名称（英文）：',
							row: 2,
							input: {
								id: 'companyNameEn',
								maxLength:100,
								c: 'text',
								check: [
									{
										do: Checker.PREDEFINED.REGEXP,
										with: /^[A-Za-z0-9().\s]+$/,
										msg: '英文名称仅允许填写大小写字母、数字、英文括号、英文符号点"."'
									}
								]
							}
						},
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{
							label: '统一社会信用证代码：',
							row: 3,
							input: {
								id: 'idNo',
								c: 'text',
								maxLength:18,
								readonly: false,
								check: Checker.LUXURIANT.REQUIRED
							}
						},
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{
							label: '公司注册地址：',
							row: 4,
							input: {
								id: 'address',
								maxLength:100,
								c: 'text'
							}
						},
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{
							label: '经营范围：',
							row: 5,
							input: {
								id: 'natureOfBusiness',
								maxLength:100,
								check: Checker.LUXURIANT.REQUIRED,
								c: 'text'
							}
						},
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{
							label: '联系人：',
							row: 6,
							input: {
								id: 'contacts',
								maxLength:100,
								check: Checker.LUXURIANT.REQUIRED,
								c: 'text'
							}
						},
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{ c: 'label', css: () => 'flex-grow: 1;' },												
						{
							label: '联系电话：',
							row: 7,
							input: {
								id: 'mobile',
								c: 'text',
								maxLength:20
							}
						},
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{
							label: '联系邮箱：',
							row: 8,
							input: {
								id: 'email',
								c: 'text',
								readonly: false,
								maxLength:100,
								check: [
									Checker.LUXURIANT.REQUIRED,
									Checker.LUXURIANT.EMAIL
								]
							},
							ref: this.emailRef
						},
						{
							label: `点击发送邮箱验证码 ${this.state.interval ? `${this.state.interval}秒` : ''}`,
							row: 8,
							c: 'button',
							type: ButtonType.PRIMARY,
							disabled: !!this.state.interval,
							// interval: 60,
							css: () => 'width: 190px;&[disabled]{opacity:.5}',
							onClick: this.onValidateMailClicked						},
						{
							visible: true,
							label: '邮箱验证码：',
							row: 9,
							placeholder: '请输入邮箱验证码',
							input: {
								id: 'emailCode',
								check: Checker.LUXURIANT.REQUIRED,
								c: 'text'
							}
						},
						{
							visible: true,
							label: '登录密码：',
							row: 10,
							input: {
								c: 'pwd',
								id: 'password',
								placeholder:'至少8位，包含大小写字母数字',
								maxLength: 20,
								check: [
									Checker.LUXURIANT.REQUIRED,
									// {
									// 	do: Checker.PREDEFINED.REGEXP,
									// 	// !"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~
									// 	// eslint-disable-next-line
									// 	with: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@\[\]^_`{|}~])[^]{8,20}$/,
									// 	msg: '密码强度不足, 请仔细阅读密码规则.'
									// }
									{
										do: Checker.PREDEFINED.REGEXP,
										// !"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~
										// eslint-disable-next-line
										with: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,20}$/,
										msg: '密码需为8-20位字符，包含大小写字母和数字。请重新输入！'
									}
								]
							}
						},
						{
							visible: true,
							label: '确认密码：',
							row: 11,
							input: {
								c: 'pwd',
								id: 'repeatPassword',
								placeholder:'至少8位，包含大小写字母数字',
								maxLength: 20,
								check: [
									Checker.LUXURIANT.REQUIRED,
									{
										do: options => {
											const { model } = options;
											return model.repeatPassword === model.password;
										},
										msg: '请保持密码相同, 并重新输入.'
									}
								]
							}
						},									
						{
							label: '上传营业执照副本：',
							row: 12,
							input: {
								id: 'file',
								c: 'filePicker',
								oss: true,
								check: {
									do: Checker.PREDEFINED.REQUIRED,
									msg: '请选择需要上传的文件.'
								},
								desc:'仅支持JPG/PNG/PDF格式',
								css: () => 'flex-grow: 2;',
								accept: '.jpg,.png,.jpeg,.PDF'
							}
						}
					]
				} as JLPanelBody,
				footer: {
					children: [
						// 放一个空label在这里撑开位置
						{ c: 'label', css: () => 'flex-grow: 1;' },
						{
							c: 'button-group',
							children: [							
								{
									c: 'button',
									label: '确认',
									type: ButtonType.PRIMARY,
									onClick: this.onConfirmClicked
								},
								{
									c: 'button',
									label: '退出',
									type: ButtonType.WAIVE,
									onClick: this.onCancelClicked
								}
							]
						}
					]
				}
			} as JLLayout;
	}

	protected getModel() {
		return Modeller.asProxied(this.model);
	}

	private onCancelClicked = (): void => {
		this.getHelpers().getRouter().replaceRedirect(PATH.DESK_SIGN);
	};
	private onConfirmClicked = async () => {
		await this.form.current.checkAllData();
		try {
			const model = Object.assign({}, this.model);
			Object.entries(model).forEach(([k, v]) => {
				if (Utils.isString(v)) {
					model[k] = v.trim();
				}
			});
			delete model.file;
			model.businessLicenseUrl = 'temp';
			let response: AjaxResponse = await this.getHelpers().getAjax().post(Apis.ACCOUNT_CREATE, model, { loading: true })
			if (response.body?.returnCode==='RC-00001'){
				Alert.success('注册成功.').then(() => {
					this.uploadBusinessLicense(response.body);
				});
			} else {
				if (response.body?.returnCode === 'RC-99998') {
					this.getModel().emailCode = '';
					this.getModel().password = '';
					this.getModel().repeatPassword = '';
					this.forceUpdate();
				}
				Alert.warn(response.body?.message);
			}
		} catch (e) {
			Alert.error('注册失败，请稍后重新尝试')
		}
	};
	private uploadBusinessLicense = async (accountRes: any) => {
		try {
			Alert.ing('营业执照副本上传中...');
			//注册成功后拿到auth，上传oss
			let url = await new OssKit().uploadFile(this.model.file, 'register/'+ this.model.idNo+'.jpg', accountRes.authToken)
			this.model.businessLicenseUrl = url;
			delete this.model.file;
			Object.entries(this.model).forEach(([k, v]) => {
				if (Utils.isString(v)) {
					this.model[k] = v.trim();
				}
			});
			//上传oss成功，更新account的businessLicenseUrl
			let response = await this.getHelpers().getAjax().post(Apis.ACCOUNT_UPDATE, this.model, { loading: true });
			if (response.body?.returnCode==='RC-00001'){
				Alert.hide();
				this.getHelpers().getRouter().replaceRedirect(PATH.DESK_SIGN);
			} else {
				Alert.warn(response.body?.message);
			}
		} catch (e) {
			console.log('upload business license error', e);
			Alert.warn('上传营业执照副本失败，请联系客服').then(() => {
				this.getHelpers().getRouter().replaceRedirect(PATH.DESK_SIGN);
			});
		}
	}
	private onValidateMailClicked = async () => {
		let emailValid = await this.emailRef.current.labelledRef.current.checkData();
		if (emailValid.rule) {
			this.timer && clearInterval(this.timer);
			this.setState({interval: 0});
			return;
		} else {
			this.setState({interval: 60});
			this.timer = setInterval(() => {
				let interval = this.state.interval
				if (interval> 0) {
					this.setState({ interval: --interval });
				}
			}, 1000);
		}
		const model = Object.assign({}, this.model);
		this.getHelpers()
		.getAjax()
		.get(Apis.REGISTER_VERIFICATION_SEND_MAIL.replace(':email', model.email as string))
		.then((response: AjaxResponse) => {
			console.log(response);
			Alert.info("邮箱验证码已发送，请登录邮箱查看");
			Promise.resolve();
		})
		.catch(() => {
			Alert.warn('发送验证码失败');
			Promise.reject();
		})
	};
}

export default DeskAccountCreate;
